import { getSummaryOrder } from '@/api/order-api';
import { useCollectionData } from '@/hooks/use-api';

export function useSaleOrderSummary() {
  const { data, isLoading, refresh, mutate } = useCollectionData(
    'sale-order-summary',
    () => getSummaryOrder(),
    {
      revalidateOnFocus: false,
    },
  );

  return {
    totalOrders: data?.totalOrders ?? 0,
    totalItems: data?.totalSoldItems ?? 0,
    paidAmount: data?.totalPaidAmount ?? 0,
    currency: '$',
    isLoading,
    refresh,
    mutate,
  };
}
